module.exports = __webpack_public_path__ + "img/tech.a678f5e2.svg";